let browserHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
let browserWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

let scrollPosition = window.pageYOffset,
  lastScrollPosition = scrollPosition,
  ticking = false;

const body = document.body, header = document.querySelector(".header");

// Check we're on the frontend.
if(header) {
  var scrollCutoff = header.offsetHeight - 15;

  function nucleoHeaderPosition() {
    scrollPosition = window.pageYOffset;
    if (scrollPosition > scrollCutoff) {
      header.classList.add("header--is-opaque");
      if (scrollPosition > lastScrollPosition) {
        body.classList.remove("scrolling-up");
        header.classList.add("header--is-hidden");
      } else {
        body.classList.add("scrolling-up");
        header.classList.remove("header--is-hidden");
      }
    } else {
      header.classList.remove("header--is-opaque");
    }
    lastScrollPosition = scrollPosition;
  }

  const fcElement = document.querySelector('.fixed-contact');
  const fcTriggers = document.querySelectorAll('img');

  function checkFixedContactOverlap() {
    var fcBox = fcElement.getBoundingClientRect();
    for (var i = 0; i < fcTriggers.length; i++) {
      let fcTriggerPos = fcTriggers[i].getBoundingClientRect();
      // Check if element is within bounds of image dimensions.
      if (fcBox.top <= (fcTriggerPos.top + fcTriggerPos.height) && fcBox.top > fcTriggerPos.top && (fcBox.bottom - 90) < fcTriggerPos.bottom && fcBox.left > fcTriggerPos.left && fcBox.right < fcTriggerPos.right) {
        var isOverlap = true;
      }
    };
    if (isOverlap) {
      fcElement.classList.add('reverse');
    } else {
      fcElement.classList.remove('reverse');
    }
  }

  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        nucleoHeaderPosition();
        checkFixedContactOverlap();
        ticking = false;
      });
      ticking = true;
    }
  });

  window.addEventListener("resize", function () {
    nucleoHeaderPosition();
    checkFixedContactOverlap();
  });

  document.addEventListener('DOMContentLoaded', (event) => {
    nucleoHeaderPosition();
    checkFixedContactOverlap();
  });

  window.addEventListener('load',function(){
    checkFixedContactOverlap();
  })
}

